import { default as api } from 'config/authApiConf.js';

export const blogDetailService = async (id = null) => {
	try {
		let result = await api.get(`/cms/blog-details/${id}`);
		return result;
	} catch (error) {
		return error;
	}
};

export const blogEditService = async (id = null, data = {}) => {
	try {
		let result = await api.put(`/cms/edit-blog/${id}`, data);
		return result;
	} catch (error) {
		return error;
	}
};
